module.exports = __webpack_public_path__ + "static/media/7.52e18b73.png";